import { VenueBranch } from '@inplay/models';
import { ForgotPasswordResponse } from '../../service/service.type';
import { OrganizationUnitChildItem } from '../organizationUnitDropdown/organizationUnitDropdown.type';

export const VENUE_UNIT_DETAILS_KEY = 'venueUnitDetails';

export const VENUE_UNIT_DETAILS = JSON.parse(
  localStorage.getItem(VENUE_UNIT_DETAILS_KEY) || '{}',
);

export type ViewUniversalStaffLoginModalProps = {
  onClose: () => void;
};

export type EditUniversalStaffLoginModalProps = {
  onClose: () => void;
  selectedBranch: OrganizationUnitChildItem;
  setSelectedBranch: (selectedChildItem: OrganizationUnitChildItem) => void;
  setShowChangePasswordSuccessToast?: (show: boolean) => void;
};

export type EditUniversalStaffLoginModalFormData = {
  email: string;
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
  venueBranchId: string;
};

export type ResetUniversalStaffLoginModalFormData = {
  email: string;
  password: string;
  venueBranchId: string;
  verificationCode: string;
  confirmPassword: string;
};

export type PasswordChangeResponse = {
  statusCode: number;
  data: ForgotPasswordResponse;
};

export type ExtendedVenueBranch = VenueBranch & {
  _id: string;
  universalStaffEmail?: string;
  userCount?: number;
};

export enum UniversalStaffLoginModalType {
  ADD = 'add',
  RESET = 'reset',
}
